// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1-3NN","colMin":"styles_colMin__1VfqN","colCheckbox":"styles_colCheckbox__299LK"};